import DropdownInput from '../../../inputs/form-inputs/DropdownInput';

import { useDynamicEntityStoreContext } from '../../contexts';

export default function CategorySchemaMapperInput({ handleChange, value }) {
  const assignedCategory = useDynamicEntityStoreContext((state) => state.data.assigned_category);

  const isAssigned = typeof value === 'string' && value.startsWith('{{') && value.endsWith('}}');

  return (
    <div className="d-flex flex-column gap-1">
      <label className="text-muted">Map to a category schema field</label>
      <DropdownInput
        formattedDropdownValues={assignedCategory.schema?.map((schema) => ({
          value: `{{${schema.name}}}`,
          label: schema.name,
        }))}
        value={value}
        onChange={(e) => handleChange(e.value ? e.value : undefined)} // We use {{ }} here as its a widely recognised template convention
        placeholder="Select a category schema field"
        isClearable
      />
      {isAssigned && <span className="text-muted">Please unassign this field to revert back to entering values.</span>}
    </div>
  );
}
